import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row, Card, CardBody, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import * as corporateAction from '../../corporate/action'
import * as caseCreateAction from '../../../Analyst/Cases/Create/actions'
// import Modal from '../../../components/UI/Modal/Modal'
import BuyForm from './BuyForm'
import KycBuyForm  from './KycBuyForm';
import { GLOBAL_SEARCH_RESULT_BUY } from '../constant';
import { MODAL_TYPE_FORM } from '../../../constants';
import CorporateModal from '../../../components/UI/CorporateModal';
import { Preloading } from '../../../components/UI/Preloader/action';
import { toast } from 'react-toastify';
// import * as constants from '../constant'
class ViewCounterParty extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            body: null,
            modalType: MODAL_TYPE_FORM,
            modalTitle: '',
            modalCloseHandler: () => { },
            selectedProductCategory:null
        }
    }
    componentDidMount() {
        this.props.viewSelectedCounterparty(this.props.match.params.id)
       // this.props.getZone();

    }
    handleBack = () => {
        // this.props.history.push(`/search-result/${this.props.searchParam}/${this.props.searchText}`)
        this.props.history.goBack();
    }

    handleToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal
        }))
    }

    handleBuy = () => {
        this.handleToggle();
        this.setProductCategory();
        this.setState({
            body: <div>
                <BuyForm toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory} selectedvalue="" zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={GLOBAL_SEARCH_RESULT_BUY} selectedCounterParty= {this.props.selectedCounterParty}  />
            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for - ' + this.props.selectedCounterParty.counterpartyName,
            
            modalCloseHandler: this.handleToggle
        })
    }

    handleKycBuy = (isVkycRequest) => {   
        this.handleToggle();
        this.setProductCategory();
        this.setState({
            body: <div>
                <KycBuyForm toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory} selectedvalue="" zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={GLOBAL_SEARCH_RESULT_BUY} isVkycRequest ={isVkycRequest} />
            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy Kyc report for - ' + this.props.selectedCounterParty.counterpartyName,
            modalCloseHandler: this.handleToggle
        })
    }
    
    setProductCategory= () => {
        if(this.props.selectedCounterParty.country === "India"){
            let cinNumber=this.props.selectedCounterParty.cinNo
            let gstNumber=this.props.selectedCounterParty.gstNo
            let panNumber=this.props.selectedCounterParty.panNo
        if((cinNumber && cinNumber!=="Not Applicable/Available" && cinNumber!=="Not Available" && cinNumber!=="Not Applicable") ||
        (gstNumber && gstNumber.charAt(5)==='C')||
        (panNumber && panNumber.charAt(3)==='C') ) {
            this.setState({
                selectedProductCategory : "CORPORATE"
            });
            }
            else{
                this.setState({
                    selectedProductCategory : "NON_CORPORATE"
                });
            }
        }else{
            this.setState({
                selectedProductCategory : "INTERNATIONAL"
            });
        }
    }
    componentDidUpdate(prevProps) {

        if(this.props.selectedCounterParty.state && this.props.selectedCounterParty.state !== prevProps.selectedCounterParty.state){
            this.props.getZoneForState(this.props.selectedCounterParty.state);
        }
        if (!this.props.result.error && this.props.result !== prevProps.result) {
            this.props.preloading(false)
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Report Request Created Successfully
                </div>
            );

        }
        else if (this.props.result.error && this.props.result !== prevProps.result) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{(this.props.result.error.response && this.props.result.error.response.data) ? this.props.result.error.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
            
            //this.props.history.push(`/case/view/${this.props.result.data.caseId}`)
        }
    }
    handleBuySuccess = () => {
        this.props.history.push('/my-portfolio')
    }


    handleUpdate = () => {
        this.handleToggle();
        this.setState({
            body: <div>
                <h5>Are you Sure You want to Update ???</h5>
                <Button color="success" onClick={this.onUpdate}>OK</Button>
                <Button color="danger" onClick={this.handleToggle}>Cancel</Button>
            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Please confirm',
            modalCloseHandler: this.handleToggle
        })
    }

    onUpdate = () => {

    }

    handleUpgrade = () => {
        this.handleToggle();
        this.setState({
            body: <div>
                <h5>Are you Sure You want to Upgrade ???</h5>
                <Button color="success" onClick={this.onUpgrade}>OK</Button>
                <Button color="danger" onClick={this.handleToggle}>Cancel</Button>
            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Please confirm',
            modalCloseHandler: this.handleToggle
        })
    }

    onUpgrade = () => {

    }

    render() {

        let buyButton
        let upgradeButton
        let updateButton
        let eKycBuyButton
        let vkycBuyButton
        // if (this.props.selectedCounterParty.actions) {
        //     if (this.props.selectedCounterParty.actions.includes(constants.CREATE))
        buyButton = <Button color="primary" className="ml-2" onClick={this.handleBuy}><i className="fa fa-shopping-cart"></i> &nbsp;BUY</Button> 
        eKycBuyButton = <Button color="primary" className="ml-2" onClick={() => this.handleKycBuy(false)}><i className="fa fa-shopping-cart"></i> &nbsp;EKYC BUY</Button> 
        vkycBuyButton = <Button color="primary" className="ml-2" onClick={() => this.handleKycBuy(true)}><i className="fa fa-shopping-cart"></i> &nbsp;VKYC BUY</Button> 
        
        // }
        const { selectedCounterParty } = this.props
        if(this.props.selectedCounterParty.country === 'India'){
            return (
                <Col>
                    <Breadcrumb className="mb-3">
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to={'/search-result/' + this.props.searchParam + '/' + this.props.searchText}>Search Results</Link></BreadcrumbItem>
                        <BreadcrumbItem active>View Counterparty Details</BreadcrumbItem>
                    </Breadcrumb>
                    <Row>
                        <Col>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="mb-0">View Counterparty Details</h4>
                            </div>
                            <Card>
                                <CardBody>
                                    <button type="button" className="btn btn-light mb-3" title="Go Back" onClick={this.handleBack}>
                                        <span className="fa fa-arrow-left" aria-hidden="true"></span>
                                        &nbsp;&nbsp;Back to search results
                                    </button>
                                        <div className="row mb-4">
                                            <div className="col-md-24">
                                                <table className="table table-bordered">
                                                    <tbody>
                                                        <tr>
                                                            <th>Name</th>
                                                            <td>{selectedCounterParty.counterpartyName}</td>
    
                                                        </tr>
                                                        <tr><th>Address</th>
                                                            <td>{selectedCounterParty.address}
                                                            </td></tr>
                                                        <tr>
                                                            <th>State</th>
                                                            <td>{selectedCounterParty.state}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>GST No.</th>
                                                            <td>{selectedCounterParty.gstNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>PAN No.</th>
                                                            <td>{selectedCounterParty.panNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Counterparty Status</th>
                                                            <td>{selectedCounterParty.counterpartyStatus}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>CIN No.</th>
                                                            <td>{selectedCounterParty.cinNo}</td>
                                                        </tr> 
                                                        <tr>
                                                            <th>Last Report Updated Date</th>
                                                            <td>{selectedCounterParty.lastDataDate}</td>
                                                        </tr> 
                                                        
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    <div>
                                        {buyButton}
                                        {eKycBuyButton}
                                        {vkycBuyButton}
                                        {upgradeButton}
                                        {updateButton}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
    
                    <CorporateModal toShow={this.state.showModal}
                        modalClosed={this.state.modalCloseHandler}
                        modalType={this.state.modalType}
                        body={this.state.body}
                        title={this.state.modalTitle} />
                </Col>
    
            )
        }else{
        return (
            <Col>
                <Breadcrumb className="mb-3">
                    <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem><Link to={'/search-result/' + this.props.searchParam + '/' + this.props.searchText}>Search Results</Link></BreadcrumbItem>
                    <BreadcrumbItem active>View Counterparty Details</BreadcrumbItem>
                </Breadcrumb>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">View Counterparty Details</h4>
                        </div>
                        <Card>
                            <CardBody>
                                <button type="button" className="btn btn-light mb-3" title="Go Back" onClick={this.handleBack}>
                                    <span className="fa fa-arrow-left" aria-hidden="true"></span>
                                    &nbsp;&nbsp;Back to search results
                                </button>
                                    <div className="row mb-4">
                                        <div className="col-md-24">
                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <th className="col-md-6">Name</th>
                                                        <td>{selectedCounterParty.counterpartyName}</td>

                                                    </tr>
                                                    <tr><th className="col-md-6">Address</th>
                                                        <td>{selectedCounterParty.address}
                                                        </td></tr>
                                                    <tr>
                                                        <th className="col-md-6">State</th>
                                                        <td>{selectedCounterParty.state}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="col-md-6">Country</th>
                                                        <td>{selectedCounterParty.country}</td>
                                                    </tr> 
                                                    <tr>
                                                        <th className="col-md-6">Last Report Updated Date</th>
                                                        <td>{selectedCounterParty.lastDataDate}</td>
                                                    </tr> 
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                <div>
                                    {buyButton}
                                    {upgradeButton}
                                    {updateButton}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <CorporateModal toShow={this.state.showModal}
                    modalClosed={this.state.modalCloseHandler}
                    modalType={this.state.modalType}
                    body={this.state.body}
                    title={this.state.modalTitle} />
            </Col>

        )
    }
    }
}

const mapStateToProps = (state, ownProps) => ({
    searchParam: state.corporate.searchParam,
    searchText: state.corporate.searchText,
    selectedCounterParty: state.corporate.selectedCounterParty,
    result: state.createCase.result,
    zoneFromState: state.createCase.zoneForState,
})

const mapDispatchToProps = (dispatch) => ({
    viewSelectedCounterparty: (id) => { dispatch(corporateAction.viewSelectedCounterparty(id)) },
    getZone: () => { dispatch(caseCreateAction.getZone()) },
    getZoneForState :(state) =>{dispatch(caseCreateAction.getZoneForState(state))},
    preloading: (status) => { dispatch(Preloading(status)) }

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCounterParty)
